<template>
  <div class="qrcode-wrapper">
    <img src="https://files.wondercv.com/translate-img/new_wondercv_logo_zh-CN.png" alt="" class="logo" />
<!--    <qrcode-vue class="qrCodeImg" :value="qrcodeParams.uuid" :size="qrcodeParams.size"/>-->
    <div class="qrCodeImg" style="position: relative">
      <img :src="qrCodeData.url" alt="" class="qrCodeImg" @load="isImageLoading=false" v-show="!isImageLoading">
      <span class="el-icon-loading" v-show="isImageLoading"></span>
<!--      <img src="https://files.wondercv.com/auth/qrcode_reload.png" alt="" class="qrCodeReload pa cursor_p" @click="getQrcode()" v-if="qrCodeData.checkSize<1">-->
    </div>
    <img src="https://files.wondercv.com/auth/qrcode_reload.png" alt="" class="qrCodeReload" @click="getQrcode()" v-show="qrCodeData.checkSize<1">
    <span class="tips">使用<span class="app-name">「超级简历APP」</span>扫码登录</span>
    <a :href="href" class="other">其他方式登录</a>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
import actions from '@/actions/index'
import qrcodeVue from 'qrcode-vue'
import * as utils from '@/utils/utils'

export default {
  data () {
    return {
      qrcodeParams: {
        size: 92, // 图片大小
        bgColor: '#fff', // 背景颜色
        fgColor: '#000', // 二维码颜色
        uuid: '' // 唯一标识
      },
      isExpired: false, // 二维码失效 boolean
      isImageLoading: false,
      expiredTime: 42000, // 二维码失效 时间
      expiredtimer: null, // 二维码失效 定时器
      checkTime: 3000, // 检查是否登录 时间
      checkTimer: null, // 检查是否登录 定时器
      href: '',    // 跳转登录页
      qrCodeData:{ //二维码参数
        url:'',
        uuid: '',
        checkSize:57/3, // 轮训次数
      },
      qrCodeTimeoutName:null, // 微信登录轮训定时器
      qrCodeQuery:{ // 获取二维码参数
        expire_seconds:60, //二维码有效期
        operation_type: 'login', //login/bind
        scene_str:'signin_' + uuid.v1(), //场景值 {扫码业务}+{身份} 扫码业务：login 扫码业务(string):login 例如login_动态的uuid
        account_type:'cv_account', //账户种类 hr_account 或 cv_account
      },
      loginFlag: true   // 扫码登录开关，谁先扫码验证成功登录的就是谁的账号
    }
  },
  components: {
    // qrcodeVue
  },
  created () {
    this.getQrcode()
    if (process.env.VUE_APP_ENV_TYPE === 'development' || process.env.VUE_APP_ENV_TYPE === 'staging') {
      this.href = 'https://www.wondercv.cn/auth-signin/?type=login'
    } else {
      this.href = 'https://www.wondercv.com/auth-signin/?type=login'
    }
  },
  methods: {
    //【微信】获取二维码
    getQrcode(){
      //轮训倒计时
      this.qrCodeData = { //二维码参数
        url:'',
        uuid: '',
        checkSize:57/3, // 轮训次数
      }
      //清除定时器
      clearInterval(this.qrCodeTimeoutName);
      this.isImageLoading = true
      //获取二维码接口
      actions.auth.getWechatQrCode(this.qrCodeQuery).then(res=>{
        if(res.code === 1000){
          this.qrCodeData.url = res.data.url;
          this.qrCodeData.uuid= res.data.qr_url.split('/').pop()
          this.getUniCode()
          //轮训倒计时
          this.qrCodeData.checkSize = 57/3;
          // 【微信/自定义扫码登录】检测是否登录
          this.checkWechatLogin();
        }else{
          this.$message.error(res.message);
        }
      })

    },
    // 生成唯一标识
    // getUuid () {
    //   this.expiredTime = 42000
    //   this.qrcodeParams.uuid = uuid.v1()
    //   // 将最新 uuid 存储到后端
    //   this.getQrcode()
    // },
    /***
     * 请求生成唯一标识
     * nums: 轮训次数
     * ***/
    getUniCode (nums) {
      // 请求失败5次不再进行请求
      if (nums && nums === 4) {
        return
      }
      let params = {
        uuid: this.qrCodeData.uuid
      }
      actions.auth.getAppQrcode(params).then(res=>{
        if(res.code === 1000){

        }else{
          // 请求失败再次进行请求并把请求数 +1
          if (nums) {
            this.getUniCode(nums++)
          } else {
            this.getUniCode(1);
          }
          this.$message.error(res.message)
        }
      })
    },
    //【微信/自定义扫码登录】检测是否登录
    checkWechatLogin(){
      this.qrCodeTimeoutName = setInterval(() => {
        this.verifyLogin()
        this.resultWechat();
        this.qrCodeData.checkSize = this.qrCodeData.checkSize-1;
        if(this.qrCodeData.checkSize<1){
          clearInterval(this.qrCodeTimeoutName);
        }
      }, 3000);
    },
    //【微信】验证是否登录
    resultWechat(){
      let query = {
        scene_str: this.qrCodeQuery.scene_str,
        operation_type: 'login'
      }
      actions.auth.result_wechat({account_type:this.account_type, params: query }).then(async res=>{
        if(res.code === 1000){
          if (this.loginFlag) {
            this.loginFlag = false
            let { jwt, jwt_timestamp, new_account} = res.data;
            this.$message({
              message: '登录成功，页面正在跳转…',
              type: 'success',
              duration: 0
            });
            clearInterval(this.qrCodeTimeoutName);
            // 插入jwt 的登录状态
            await utils.updateJWT({
              jwt,
              jwt_timestamp: jwt_timestamp
            })
            if(this.account_type === 'hr_account'){
              // 获取用户绑定信息，用作跳转
              this.getUsersBindInfo(new_account);
            }else{
              localStorage.setItem('_n_b_p', false);
              //【登录成功】读取跳转页面
              this.pageJump(new_account)
            }
          }
        }

      })
    },
    // 验证登录状态
    // 验证登录状态
    verifyLogin () {
      let params = {
        uuid: this.qrCodeData.uuid
      }
      actions.auth.verifyLoginStatus(params).then(res=>{
        if (res.code === 1000) {
          if (res.data && res.data.jwt && res.data.jwt !== 'unlogin') {
            if (this.loginFlag) {
              clearInterval(this.qrCodeTimeoutName);
              this.loginFlag = false;
              utils.updateJWT({
                jwt: res.data.jwt,
                jwt_timestamp: Math.floor(new Date().getTime() / 1000) + 14 * 24 * 60 * 60
              })
              setTimeout(() => {
                localStorage.setItem('_n_b_p', false);
                this.pageJump()
              }, 1000)
            }
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    pageJump(new_account){
      // if(new_account){
      //   //新用户跳转到cvs，然后自动会跳转到 选择身份页面
      //   window.location.href = window.location.origin+'/select_identity'
      // }else{
      let r_b_t = utils.getCookie('_r_b_t') || '';
      // 返回的url中必须有 wondercv
      if(!r_b_t.includes('wondercv')){
        r_b_t = '';
      }
      // 返回的url要进行解码再跳转
      if(r_b_t){
        r_b_t = decodeURIComponent(r_b_t);
      }
      let _t = utils.get_tUser();
      if(this.account_type==='hr_account'){
        if(!r_b_t.includes('/talent/')){
          r_b_t = '';
        }
        let hr_url = window.location.origin + `${this.isBindPhone? '/talent/userinfo':'/talent/binduser'}`
        let hr_indexUrl = window.location.origin + '/talent/search'
        //如果返回的url中包含 用户信息的url
        let link_to = r_b_t.includes(`${hr_url}`)? ( r_b_t.includes('?')?r_b_t+'&showJump=true':r_b_t+'?showJump=true' ) : `${hr_url}${r_b_t ? '?link_to='+encodeURIComponent(r_b_t)+'&showJump=true' : '?showJump=true'}`;
        // 新用户，完善hr信息
        if(new_account){
          window.location.href = window.location.origin + '/talent/binduser'
        }else{
          // hr登录之后的判断, 是否是hr，判断是否绑定手机号 判断是否读取本地地址
          window.location.href = _t.h_t ? ( this.isBindPhone ? ( r_b_t || hr_indexUrl) : link_to ) : link_to ;
        }
        utils.delCookie('_r_b_t');
      }else{
        // cv登录之后的判断
        if(r_b_t.includes('/talent/')){
          r_b_t = '';
        }
        // 不是新用户 && 有 r_b_t
        if(r_b_t && !new_account){
          window.location.href = r_b_t;
          utils.delCookie('_r_b_t');
        }else{
          //新用户跳转到cvs，然后自动会跳转到 选择身份页面
          if (process.env.VUE_APP_ENV_TYPE === 'development' || process.env.VUE_APP_ENV_TYPE === 'staging') {
            window.location.href = 'https://www.wondercv.cn/cvs'
          } else {
            window.location.href = 'https://www.wondercv.com/cvs'
          }
        }
      }
      // }
    },
  }
}
</script>

<style lang="scss" scoped>
.qrcode-wrapper {
  position: relative;
  margin: 200px auto;
  width: 340px;
  height: 363px;
  border-radius: 10px;
  box-shadow: 0px 8px 24px 0px #e8e8e8;
  background-color: #fff;
  box-sizing: border-box;
  padding: 31px 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo {
    width: 115px;
    height: 35px;
  }

  .qrCodeImg {
    margin-top: 5px;
    width: 184px!important;
    height: 184px!important;
    img {
      width: 184px !important;
      height: 184px !important;
      object-fit: contain!important;
    }
  }

  .el-icon-loading{
    position: absolute;
    font-size: 32px;
    color: #BCBCBC;
    top: calc(50% - 16px);
    left: calc(50% - 16px);
  }

  .qrCodeReload {
    width: 184px;
    height: 184px;
    position: absolute;
    top: 71px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .tips {
    margin-top: 16px;
    font-size: 14px;
    color: #404040;
    .app-name {
      color: #ff6644;
    }
  }
  .other {
    margin-top: 16px;
    font-size: 14px;
    color: #9C9C9C;
    border-bottom: 1px solid #9c9c9c;
  }
}
</style>